import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // AG Grid styles
import "ag-grid-community/styles/ag-theme-alpine.css"; // AG Grid theme
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes, { symbol } from "prop-types";
import { height, styled } from "@mui/system";
import Cookie from "js-cookie";
import { useNavigate } from "react-router-dom";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import {
  TableContainer,
  Paper,
  Grid,
  TextField,
  Dialog,
  Typography,
  CircularProgress,
  DialogContent,
  DialogActions,
  DialogContentText,
  Tooltip,
  Autocomplete,
  IconButton,
  InputAdornment,
  Box,
} from "@mui/material";
import {
  ViewButton,
  DeleteButton,
  StyledTypography,
  StyledButton,
  StyledButtonC,
  StyledAlert,
  StyledSnackbar,
  inputStyle,
  StyledAgGridContainer,
  StyledTableContainer,
} from "components/StyledComponents/styledComponents.js";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import { employeeStyles } from "components/Styles/employeeMasterStyles";
import { subDialogContentStyle, dialogContentTextStyle } from "components/Styles/approvalStyles";
import URLs from "constants/urls";
import { selectScrollStyle, CustomPaper } from "components/Styles/globalStyles";
import { globalStyles } from "components/Styles/globalStyles";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export default function AccessControl() {
  const [isEditMode, setIsEditMode] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [tableData, setTableData] = useState([]);
  const [loginAccessData, setLoginAccessData] = useState([]);
  const [employeeCode, setEmployeeCode] = useState(0);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const jwt_token = Cookie.get("jwt_token");
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const MInput = inputStyle();
  const fetchEmployeeData = async () => {
    setLoading(true);
    const url = URLs.hrmsEmployeeMasterGetUrl;
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };

      const response = await fetch(url, options);

      // First check if response is ok before trying to parse JSON
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text(); // Get response as text first

      // Check if response is empty
      if (!text) {
        throw new Error("Empty response received from server");
      }

      // Try to parse the text as JSON
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("JSON Parse Error:", e);
        console.error("Raw response:", text);
        throw new Error("Invalid JSON response from server");
      }

      if (Array.isArray(data)) {
        setTableData(data);
      } else if (data && typeof data === "object") {
        // If data is an object but not an array, check if it has a data property
        const employeeArray = data.data || data.employees || Object.values(data);
        if (Array.isArray(employeeArray)) {
          setTableData(employeeArray);
        } else {
          throw new Error("Response data is not in expected format");
        }
      } else {
        throw new Error("Invalid data format received");
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setAlert(error.message || "Failed to fetch employee data", "error");
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchLoginAcceccedData = async () => {
    setLoading(true);
    const url = URLs.appAccessURl;
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(url, options);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch login access data");
      }

      setLoginAccessData(data);
      resetForm();
    } catch (error) {
      console.error("Error fetching login access data:", error);
      setAlert(error.message || "Failed to fetch login access data", "error");
      setLoginAccessData([]);
    } finally {
      setLoading(false);
    }
  };
  const accesControlApiCall = async () => {
    setLoading(true);
    const url = URLs.accessControlApi;
    try {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
        body: JSON.stringify({
          employeeId: employeeId,
          companyId: companyId,
          employeeCode: employeeCode,
          employeePassword: password,
        }),
      };
      const response = await fetch(url, options);
      const data = await response.json();
      if (!response.ok) {
        setAlert(data.message || "An error occurred", "error");
      } else {
        setAlert(data.message || "Success", "success");
        fetchLoginAcceccedData();
      }
    } catch (error) {
      setAlert("Data not Fetched: " + error.message, "error");
    } finally {
      setLoading(false);
    }
  };
  const updatePasswordData = async () => {
    setLoading(true);
    const url = `${
      URLs.hrmsUpdatePassword
    }?employeeCode=${employeeCode}&companyId=${companyId}&newPassword=${encodeURIComponent(
      password
    )}`;
    try {
      const options = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(url, options);
      if (!response.ok) {
        const data = await response.json();
        setAlert(data.message || "An error occurred while updating password", "error");
      } else {
        const data = await response.text();
        setAlert("Password updated successfully", "success");
        fetchLoginAcceccedData();
        resetForm();
        setActiveTab(0);
      }
    } catch (error) {
      console.error("Network Error:", error);
      setAlert("Failed to update password: " + error.message, "error");
    } finally {
      setLoading(false);
    }
  };
  const handleViewClick = (rowData) => {
    setIsEditMode(true);
    setEmployeeCode(rowData.employeeCode);
    setCompanyId(rowData.companyId);
    setEmployeeId(rowData.employeeId);
    setActiveTab(1); // Switch to "Give Access" tab
  };
  const handleDeleteClick = (empId, empCode) => {
    if (!empId) {
      setAlert("Employee ID is missing", "error");
      return;
    }
    setEmployeeId(empId);
    setEmployeeCode(empCode);
    setOpenDialog(true);
  };

  const employeeDeleteApiCall = async (emId) => {
    setLoading(true);
    const url = `${URLs.removeAccess}/${emId}`;

    try {
      const response = await fetch(url, {
        method: "DELETE", // Specify the HTTP method
        headers: {
          "Content-Type": "application/json", // Optional but good practice
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        // Try to get error message from response
        let errorMessage;
        try {
          const errorData = await response.json();
          errorMessage = errorData.message;
        } catch {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || `Failed to delete employee (Status: ${response.status})`);
      }

      setAlert("Employee deleted successfully", "success");
      fetchLoginAcceccedData(); // Refresh the employee list
      setIsEditMode(false);
      resetForm();
      setOpenDialog(false); // Close the confirmation dialog
    } catch (error) {
      console.error("Delete error:", error);
      setAlert(error.message || "Failed to delete employee", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmDelete = () => {
    if (!employeeId) {
      setAlert("Employee ID is missing", "error");
      return;
    }
    employeeDeleteApiCall(employeeId);
  };
  useEffect(() => {
    document.querySelectorAll("input").forEach((input) => {
      input.autocomplete = "off";
    });
  }, []);

  useEffect(() => {
    fetchLoginAcceccedData();
  }, []);
  useEffect(() => {
    fetchEmployeeData();
  }, [jwt_token]);

  // Handle the employee code change and filter the employee data
  const handleEmployeeCodeChange = (event, value) => {
    setEmployeeCode(value ? value.employeeCode : "");
    setEmployeeId(value ? value.employeeId : "");
    setCompanyId(value ? value.companyId : "");

    // Filter the employee data based on employee code
    if (value) {
      const filteredData = tableData.filter(
        (employee) => employee.employeeCode === value.employeeCode
      );
      setTableData(filteredData); // Update the Autocomplete options
    } else {
      setTableData(tableData); // If no value selected, show all employees
    }
  };

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseForm = () => {
    resetForm();
    setActiveTab(0); // Switch back to AG Grid table view
  };

  const resetForm = () => {
    setEmployeeId("");
    setPassword("");
    setEmployeeCode("");
    setCompanyId("");
    setIsEditMode(false);
    setShowPassword(false);
  };

  const ActionCellRenderer = (props) => {
    const rowIndex = props.node.rowIndex;
    const rowData = props.api.getDisplayedRowAtIndex(rowIndex).data; // Get the row data using the grid API
    return (
      <div>
        <ViewButton onClick={() => handleViewClick(rowData)}>
          <EditIcon />
        </ViewButton>
        <DeleteButton onClick={() => handleDeleteClick(rowData.employeeId, rowData.employeeCode)}>
          <DeleteIcon />
        </DeleteButton>
      </div>
    );
  };
  const columnDefs = [
    {
      headerName: "Employee Name",
      field: "employeeName",
      sortable: true,
      filter: true,
      flex: 2, // More flex to give it more space
    },
    {
      headerName: "Dsa Name",
      field: "dsaName",
      sortable: true,
      filter: true,
      flex: 2,
    },
    {
      headerName: "Employee Code",
      field: "employeeCode",
      sortable: true,
      filter: true,
      flex: 2,
    },
    {
      headerName: "Actions",
      field: "actions",
      cellRenderer: ActionCellRenderer, // Custom action cell renderer
      width: 100,
    },
  ];
  const handleSave = (e) => {
    e.preventDefault();
    if (isEditMode) {
      updatePasswordData();
    } else {
      accesControlApiCall();
    }
  };

  const tabs = [{ label: "Employees List" }, { label: "Give Access" }];

  return (
    <DashboardLayout>
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", mt: 0 }}>
        <ResponsiveTabs
          tabs={tabs}
          activeTab={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          labelColor="secondary"
          bgColor="#e0f7fa"
        />

        {activeTab === 0 && (
          <Box sx={{ mt: 2 }}>
            <StyledAgGridContainer
              component={Paper}
              className="ag-theme-alpine"
              sx={{
                flexGrow: 1,
                backgroundColor: "transparent",
                height: "calc(100vh - 200px)",
                width: "100%",
              }}
            >
              <AgGridReact
                rowData={loginAccessData}
                columnDefs={columnDefs}
                pagination={true}
                paginationPageSize={10}
                defaultColDef={{
                  resizable: true,
                  filter: true,
                }}
              />
            </StyledAgGridContainer>
          </Box>
        )}

        {activeTab === 1 && (
          <StyledTableContainer
            container
            spacing={1}
            sx={{
              display: "flex",
              backgroundColor: "#ffffff",
              minHeight: "500px",
              borderRadius: "15px",
              overflow: "auto",
              width: "100%",
            }}
          >
            <Grid
              container
              spacing={1}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                margin: "auto",
              }}
            >
              <Grid item xs={12} md={12} lg={10}>
                <div style={{ position: "relative", width: "100%" }}>
                  <StyledTypography>
                    {!isEditMode ? "Access Control" : "Re-create Password"}
                  </StyledTypography>
                  {isEditMode && (
                    <Tooltip title="Reset">
                      <StyledButtonC onClick={resetForm}>
                        <RestartAltIcon />
                      </StyledButtonC>
                    </Tooltip>
                  )}
                </div>
                <Box component="form" onSubmit={handleSave} sx={{ mt: 3 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                      <Autocomplete
                        options={tableData}
                        getOptionLabel={(option) =>
                          option
                            ? `${option.employeeCode || ""} - ${option.firstName || ""}${
                                option.lastName ? ` ${option.lastName}` : ""
                              }`
                            : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option && value ? option.employeeCode === value.employeeCode : false
                        }
                        value={
                          employeeCode
                            ? tableData.find((item) => item.employeeCode === employeeCode) || null
                            : null
                        }
                        onChange={(event, value) => {
                          setEmployeeCode(value ? value.employeeCode : "");
                          setEmployeeId(value ? value.employeeId : "");
                          setCompanyId(value ? value.companyId : "");
                        }}
                        PaperComponent={CustomPaper}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Employee Code"
                            variant="outlined"
                            required
                            error={tableData.length === 0}
                            helperText={
                              tableData.length === 0 ? "Failed to load employee data" : ""
                            }
                            sx={{
                              height: 43,
                              ...MInput.b,
                              "& .MuiInputBase-root": {
                                height: "100%",
                                minHeight: 43,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        type={showPassword ? "text" : "password"}
                        label={isEditMode ? "Re-create password" : "Create Password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        fullWidth
                        required
                        sx={MInput.b}
                        InputLabelProps={{
                          sx: {
                            color: MInput.a,
                          },
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={togglePasswordVisibility}
                                edge="end"
                                aria-label="toggle password visibility"
                              >
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
                    {isEditMode && (
                      <StyledButton
                        onClick={handleCloseForm}
                        variant="outlined"
                        sx={{ marginRight: 1 }}
                      >
                        Close
                      </StyledButton>
                    )}
                    <StyledButton type="submit">{isEditMode ? "Update" : "Save"}</StyledButton>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </StyledTableContainer>
        )}
      </Box>

      <Dialog
        open={loading}
        onClose={() => setLoading(false)}
        aria-labelledby="loading-dialog-title"
      >
        <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <CircularProgress color="primary" />
          <Typography variant="h6" style={{ marginTop: "20px" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>

      <Dialog open={openDialog}>
        <DialogContent sx={subDialogContentStyle}>
          <DialogContentText sx={dialogContentTextStyle}>
            {`Are you sure you want to remove Access control to ${employeeCode} employee `}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={employeeStyles.dialogActions}>
          <StyledButton onClick={handleConfirmDelete}>Yes</StyledButton>
          <StyledButton onClick={() => setOpenDialog(false)} variant="outlined">
            No
          </StyledButton>
        </DialogActions>
      </Dialog>

      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
    </DashboardLayout>
  );
}
AccessControl.propTypes = {
  data: PropTypes.object.isRequired,
  node: PropTypes.shape({
    rowIndex: PropTypes.number.isRequired,
  }).isRequired,
  api: PropTypes.shape({
    getDisplayedRowAtIndex: PropTypes.func.isRequired,
  }).isRequired,
};
